import React from 'react';
import { ReactFCC } from '@bbkAdminUtils/utility-types';

export const NavContainer: ReactFCC = ({ children }) => (
  <li className="bbk-nav-container">
    <span>{children}</span>
  </li>
);
